(function () {
  function initCarousel(container) {
    if (container.hasAttribute('data-carousel-initialized')) return;
    container.setAttribute('data-carousel-initialized', '');

    const scrollDiv = container.querySelector('.multi-carousel-scroll');
    const track = scrollDiv ? scrollDiv.querySelector('.multi-carousel-track') : null;
    if (!scrollDiv || !track) return;

    const cards = Array.from(track.querySelectorAll('.multi-carousel-card'));
    const totalItems = cards.length;
    if (totalItems === 0) return;

    container.querySelectorAll('.multi-btn-prev, .multi-btn-next, .multi-carousel-dots').forEach((el) => el.remove());

    const prevBtn = document.createElement('button');
    prevBtn.className = 'multi-carousel-btn multi-btn-prev';
    prevBtn.innerHTML = '‹';
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Previous slide');

    const nextBtn = document.createElement('button');
    nextBtn.className = 'multi-carousel-btn multi-btn-next';
    nextBtn.innerHTML = '›';
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Next slide');

    container.appendChild(prevBtn);
    container.appendChild(nextBtn);

    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'multi-carousel-dots';
    container.appendChild(dotsContainer);

    let currentIndex = 0;
    let scrollTimer = null;
    let rafId = null;

    function getMaxScrollLeft() {
      return scrollDiv.scrollWidth - scrollDiv.clientWidth;
    }

    function scrollToCardIndex(index, smooth = true) {
      if (totalItems === 0) return;
      if (index < 0) index = 0;
      if (index >= totalItems) index = totalItems - 1;
      if (!cards[index]) return;

      let targetLeft = 0;
      if (index === 0) {
        targetLeft = 0;
      } else if (index === totalItems - 1) {
        targetLeft = getMaxScrollLeft();
      } else {
        targetLeft = cards[index].offsetLeft;
      }

      const maxScroll = getMaxScrollLeft();
      targetLeft = Math.min(maxScroll, Math.max(0, targetLeft));

      scrollDiv.scrollTo({
        left: targetLeft,
        behavior: smooth ? 'smooth' : 'auto',
      });
    }

    function computeNearestCardIndex() {
      if (!cards.length) return 0;
      const scrollLeft = scrollDiv.scrollLeft;
      const maxScroll = getMaxScrollLeft();
      if (scrollLeft <= 2) return 0;
      if (scrollLeft >= maxScroll - 2) return totalItems - 1;

      let minDistance = Infinity;
      let nearestIndex = 0;
      for (let i = 0; i < cards.length; i++) {
        const distance = Math.abs(scrollLeft - cards[i].offsetLeft);
        if (distance < minDistance) {
          minDistance = distance;
          nearestIndex = i;
        }
      }
      return nearestIndex;
    }

    function updateDotsActive() {
      dotsContainer.querySelectorAll('.multi-dot').forEach((dot, i) => {
        dot.classList.toggle('active', i === currentIndex);
      });
    }

    function updateButtonsState() {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === totalItems - 1;
    }

    function updateUIFromScroll() {
      const newIndex = computeNearestCardIndex();
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        updateDotsActive();
      }
      updateButtonsState();
    }

    function generateDots() {
      dotsContainer.innerHTML = '';
      for (let i = 0; i < totalItems; i++) {
        const dot = document.createElement('button');
        dot.className = 'multi-dot' + (i === currentIndex ? ' active' : '');
        dot.type = 'button';
        dot.setAttribute('data-index', String(i));
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          const idx = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(idx) && idx !== currentIndex) {
            scrollToCardIndex(idx, true);
          }
        });
        dotsContainer.appendChild(dot);
      }
    }

    function onScrollHandler() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const tempIndex = computeNearestCardIndex();
        if (tempIndex !== currentIndex) {
          currentIndex = tempIndex;
          updateDotsActive();
          updateButtonsState();
        }
        rafId = null;
      });
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateUIFromScroll, 80);
    }

    function onResizeHandler() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        scrollToCardIndex(currentIndex, false);
        updateUIFromScroll();
      }, 120);
    }

    generateDots();
    setTimeout(() => {
      scrollToCardIndex(0, false);
      updateUIFromScroll();
    }, 20);

    scrollDiv.addEventListener('scroll', onScrollHandler);
    if ('onscrollend' in window) {
      scrollDiv.addEventListener('scrollend', updateUIFromScroll);
    }
    window.addEventListener('resize', onResizeHandler);
    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) scrollToCardIndex(currentIndex - 1, true);
      else updateButtonsState();
    });
    nextBtn.addEventListener('click', () => {
      if (currentIndex + 1 < totalItems) scrollToCardIndex(currentIndex + 1, true);
      else updateButtonsState();
    });
  }

  function initAllCarousels() {
    document.querySelectorAll('[data-carousel-root]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  window.addEventListener('load', () => {
    setTimeout(initAllCarousels, 100);
  });
})();
